module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('layout-ucenter', [_c('template', {
    slot: "menu"
  }, [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "router": true,
      "default-active": "1"
    }
  }, [_c('el-menu-item-group', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" 示例页面")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/demo/list"
    }
  }, [_vm._v("列表页")]), _vm._v(" "), _c('el-menu-item', {
    attrs: {
      "index": "/demo/form"
    }
  }, [_vm._v("表单页")])], 2)], 1)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-46589412!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/demo-container.vue
// module id = 220
// module chunks = 29